import React, {useMemo} from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Step from '@components/PageStep';
import {IReviewsItem} from '@common/types';
import DetailPageHeader from '@components/DetailPageHeader';
import ReviewsGrid from '@components/ReviewsGrid';


export const SolutionDetail = () => {
  const {solution} = useTypedSelector(state => state.solutions);
  const reviews = useMemo(() => solution?.detail?.cards?.map((card) => {
    return {
      title: card?.title,
      description: card?.description,
      color: card.color,
      cardType: card.cardType,
    }
  }) as IReviewsItem[] || [], [solution]);

  return (
    <>
      <DetailPageHeader {...solution?.detail}/>

      <div className={"inner-simple-block inner-simple-block--no-padding"}>
        <div className={"container"}>
          <ReviewsGrid
            type="reviews"
            reviews={reviews}
          />
        </div>
      </div>

      {solution?.steps?.map((item, index) => (
        <Step
          classNames={index + 1 !== solution?.steps?.length ? [""] : ["inner-grid inner-grid--margin-bottom"]}
          key={`step_${index}`}
          count={item.count}
          step={item.step}
          stepChildren={item.children}
        />
      ))}
    </>
  )
}
